import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';
import { alpha, Box, Button, CircularProgress, IconButton, Stack, styled, Typography } from '@mui/material';
// eslint-disable-next-line import/no-extraneous-dependencies
import { WALLET_ADAPTERS } from '@web3auth/base';
import { LOGIN_PROVIDER_TYPE } from '@web3auth/openlogin-adapter';
import { routes } from 'app/providers/router/routes';
import { useWeb3Auth } from 'app/providers/Web3AuthProvider';
import { userSelector } from 'entities/user';
import { Close } from 'pages/home/ui/Icons';
import { TwitchLogo, yandexLogo } from 'shared/assets';
import { COLOR_LIGHT_GRAY_INPUT } from 'shared/config';
import { COLOR_ACCENT, COLOR_BG, COLOR_DARK_AUTH, COLOR_WHITE } from 'shared/config/theme/colors';
import { FontFamilies, FontWeights } from 'shared/config/theme/Typography';
import { useShallowSelector } from 'shared/hooks';
import { Discord, Facebook, Google, Twitter } from 'shared/ui/components/Icon';

import logoWhite from "../../../shared/assets/ww.png";
import { useTranslation } from 'react-i18next';
import { modalActions, ModalType } from '../model';

export interface IConnectWalletPayload {
  type: ModalType.ConnectWallet;
  data?: null;
}

const StyledCircle = styled(Box)({
  width: 'calc(100% - 50px)',
  maxWidth: '600px', // Adjust as needed
  aspectRatio: '1 / 1',
  borderRadius: '50%',
  border: '2px solid #3ACACF',
  backgroundColor: '#05052d', // Example color
  fontFamily: "Montserrat, sans-serif",
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0 auto',
  padding: '20px',
  '@media (max-width: 768px)' : {
    borderRadius: '15px',
    maxWidth: 'calc(100% - 50px)',
    height: 'calc(100% - 30px)'
  }
});

const StyledButton = styled(Button)({
  backgroundColor: 'transparent',
  border: '2px solid #2DF6DE',
  color: 'white',
  '&:hover': {
    backgroundColor: '#0288D1',
  },
  marginTop: '15px',
});

const ImageOverlay = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  borderRadius: '50%',
  pointerEvents: 'none', // Allows clicking through the overlay
});

const CloseButton = styled(IconButton)({
  position: 'absolute',
  top: '10px',
  right: '10px',
  color: 'black',
  border: 'none',
  '&:hover' : {
    background: 'none'
  }
});

const BottomText = styled(Typography)({
  marginTop: '40px',
  textAlign: 'center',
});


export const ConnectWallet = () => {

  const { t } = useTranslation();
  const { login, isLoading } = useWeb3Auth();
  const user = useShallowSelector(userSelector.getUser);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { pathname } = useLocation();
  const isChakras = pathname === '/chakras';

  const handleLogin = async (provider: LOGIN_PROVIDER_TYPE) => {
    await login(WALLET_ADAPTERS.AUTH, provider);
  };

  useEffect(() => {
    if (user?.id) {
      dispatch(modalActions.closeModal());
      console.log(pathname);
      if(isChakras) {
        navigate(routes.checkPromo.path);
      } else {
        navigate(routes.connection.path);
      }
    }
  }, [isChakras, pathname, dispatch, navigate, user.firstName, user?.id, user.lastName]);

  /*return (
    <Box
      sx={{
        background: 'linear-gradient(280.89deg, #9B4DFF -3.98%, #2DF6DE 91.81%)',
        width: '100%',
        borderRadius: '16px',
        maxWidth: '510px',
      }}
    >
      <Stack
        spacing={3}
        sx={{
          backgroundColor: 'rgb(25, 24, 54)',
          borderRadius: '16px',
          margin: '3px',
          padding: '24px',
          paddingBottom: 5.5,
        }}
      >
        <Stack width="100%" direction="row" justifyContent="space-between">
          <Close
            sx={{ color: COLOR_LIGHT_GRAY_INPUT, cursor: 'pointer' }}
            onClick={() => dispatch(modalActions.closeModal())}
          />
        </Stack>
        <Stack width="100%" direction="column">
          <Typography
              fontFamily={FontFamilies.secondary}
              fontWeight={FontWeights.Medium}
              fontSize={30}
              lineHeight="30px"
          >
            {t('modal_singup')}
          </Typography>
          <Typography
              fontSize={16}
              lineHeight="20px"
          >
            {t('modal_text')}
          </Typography>
        </Stack>

        {isLoading && (
          <Box
            position="absolute"
            zIndex={9999}
            display="flex"
            alignItems="center"
            justifyContent="center"
            width="100%"
            height="100%"
            left={0}
            top={0}
            bgcolor={alpha(COLOR_BG, 0.5)}
          >
            <CircularProgress size={50} sx={{ color: COLOR_WHITE }} />
          </Box>
        )}
        <Stack width="100%" spacing={2}>
          <SocialLoginButton onClick={() => handleLogin('google')}>
            Continue with Google
          </SocialLoginButton>
          <SocialLoginButton onClick={() => handleLogin('google')}>
            Continue with Yandex / Vk
          </SocialLoginButton>
        </Stack>
      </Stack>
    </Box>
  );*/
  return (
      <StyledCircle>
        <CloseButton aria-label="close">
          <Close
              sx={{ color: COLOR_LIGHT_GRAY_INPUT, cursor: 'pointer' }}
              onClick={() => dispatch(modalActions.closeModal())}
          />
        </CloseButton>
        <Typography sx={{
          marginBottom: '40px'
        }}><img src={logoWhite} width={25} height={60} alt="loader" /></Typography>
        <Typography variant="h5" align="center" sx={{
          fontSize: '22px', fontFamily: "Montserrat, sans-serif",
        }}>{t('form_1')}</Typography>
        <Typography variant="h5" align="center" sx={{
          fontSize: '22px', fontFamily: "Montserrat, sans-serif", textAlign: 'center'
        }}>{t('form_2')}</Typography>
        <Typography variant="body2" align="center" sx={{
          marginTop: '10px',
          color: '#4f4f4f', fontFamily: "Montserrat, sans-serif", textAlign: 'center'
        }}>{t('form_3')}</Typography>

        <Typography variant="subtitle1" align="center" sx={{marginTop: '20px', textAlign: 'center', fontSize: '16px', fontWeight: '600', fontFamily: "Montserrat, sans-serif",}}>{t('form_4')}</Typography>
        {/*<Stack sx={{
          marginTop: '10px',
          color: '#4f4f4f',
          alignItems: 'center'
        }}>
          <Typography variant="body2" sx={{fontSize: '14px'}} align="center">1. Фото для Сертификата</Typography>
          <Typography variant="body2" sx={{fontSize: '14px'}} align="center">2. Видеоклятвы (до 3 минут) или возможность</Typography>
          <Typography variant="body2" sx={{fontSize: '14px'}} align="center">записать в процессе</Typography>
          <Typography variant="body2" sx={{fontSize: '14px'}} align="center">3. Код Сертификата или 111 $</Typography>
        </Stack>*/}
        <StyledButton variant="contained" sx={{ fontSize: '14px', padding: '10px 20px', height: '45px', marginTop: '40px'}} onClick={() => handleLogin('google')}>Continue with Google</StyledButton>
        {/*<StyledButton variant="contained" sx={{ fontSize: '14px', padding: '10px 20px', height: '45px'}} onClick={() => handleLogin('google')}>Continue with Yandex / VK</StyledButton>*/}
        <BottomText variant="body2" sx={{marginTop: '40px', color: '#4f4f4f', fontFamily: "Montserrat, sans-serif",}}>{t('form_5')}</BottomText>
        <BottomText variant="body2" sx={{marginTop: '0', color: '#4f4f4f', fontFamily: "Montserrat, sans-serif",}}>{t('form_6')}</BottomText>

        <ImageOverlay />
      </StyledCircle>
  );
};
